<template>
  <div class="container-fluid p-5" style=" margin-top: 50px; margin-bottom: 80px">
    <div class="d-flex flex-row justify-content-between flex-wrap pb-1 container-main-title">
      <h2 class="text-bg main-title">Mis planes</h2>
      <!-- <router-link to="/" style="text-decoration: none;">
        <n-button type="info" size="medium" style="font-size: 20px" class="confirm-btn" >
          <i class="icon-plus" style="padding-right: 12px;"></i>
          Crear nuevo Plan
        </n-button>
      </router-link> -->
    </div>

    <div class="table-responsive">
      <table class="table table-striped table-hover">
        <thead class="table-head-dark">
          <tr>
            <th scope="col" class="text-sm title-in-row" @click="this.sortColumn('name')">
              Nombre
              <i v-if="this.selectedColumn === 'name'"
                :class="this.sortDirection ? 'icon-angle-down' : 'icon-angle-up'"></i>
            </th>
            <!-- <th scope="col" class="text-sm" @click="this.sortColumn('season')">
              Temporada
              <i v-if="this.selectedColumn === 'season'"
                :class="this.sortDirection ? 'icon-angle-down' : 'icon-angle-up'"></i>
            </th> -->
            <th scope="col" class="text-sm title-in-row" @click="this.sortColumn('totalSize')">
              Tamaño total
            </th>
            <th scope="col" class="text-align text-sm title-in-row">Eliminar</th>
          </tr>
        </thead>
        <tbody>
          <tr scope="row" v-if="this.loading" style="width: 50vw; height: 2rem;">
            <td colspan="5">
              <div class="d-flex justify-content-center">
                <div class="spinner-border" role="status">
                  <span class="sr-only"></span>
                </div>
              </div>
            </td>
          </tr>
          <tr scope="row" v-else-if="!this.loading && this.plans.length === 0" style="width: 50vw; height: 2rem;">
            <td colspan="5" class="text-center">
              <n-p>No hay plan guardado. Crea uno nuevo.</n-p>
            </td>
          </tr>
          <tr style="cursor: pointer" v-else-if="!this.loading && this.plans?.length > 0"
            v-for="(plan,index) in this.plans" :key="index" @click="goToPlan(plan)">
            <td scope="row" class="align-middle text-sm info-in-row">{{plan.name}}</td>
            <!-- <td scope="row" class="align-middle text-sm">{{this.getSeason(plan.season)}}</td> -->
            <td scope="row" class="align-middle text-sm info-in-row">{{plan?.totalSize?.toFixed(2)}} has.</td>
            <td scope="row" class="align-left d-flex info-in-row">
              <div class="trash">
                <n-tooltip trigger="hover">
                  <template #trigger>
                    <span @click="handleConfirm($event, plan)"
                      style="cursor: pointer;padding-bottom: 4px; padding-right: 12px">
                      <i class="icon-trash" />
                    </span>
                  </template>
                  Eliminar
                </n-tooltip>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

    </div>

    <router-link to="/app/create-plan" style="text-decoration: none;" class="crear-nuevo-plan-container">
        <button class="btn-crear-nuevo-plan" >
          <i class="icon-plus" style="padding-right: 12px;"></i>
          Crear nuevo Plan
        </button>
      </router-link>
  </div>
</template>

<script>

import { mapActions, mapState } from 'pinia';
import { useMessage, useDialog } from 'naive-ui';
import planStore from '../../store/plan'
import authStore from '../../store/auth'

export default {
  data() {
    return {
      message: useMessage(),
      dialog: useDialog(),
      showExtraModal: false,
      currentProvider: '',
      selectedColumn: '',
      searchBar: '',
      filter: []
    }
  },
  computed: {
    ...mapState(authStore, ['isLoggedIn']),
    ...mapState(planStore, ['plans', 'sortDirection', 'loading']),
    getSeason() {
      return (season) => {
        if (!season) {
          return 'No definido'
        } else if (season === 'summer') {
          return 'Verano'
        } else return "Invierno"
      }
    }
  },
  methods: {
    ...mapActions(planStore, ['getPlans', 'removePlan', 'sortPlans']),
    sortColumn(key) {
      this.sortPlans(key);
      this.selectedColumn = key;
    },
    goToPlan(plan) {
      this.$router.push({
        name: 'edit-plan',
        params: { id: plan._id }
      })
    },
    handleConfirm(event, plan) {
      event.stopPropagation()
      this.dialog.warning({
        title: "Confirmar",
        content: "Esta seguro que desea eliminar el plan?",
        positiveText: "ACEPTAR",
        negativeText: "CANCELAR",
        onPositiveClick: () => {
          this.deletePlan(plan._id)
        },
        onNegativeClick: () => {
          this.message.error("Acción cancelada");
        }
      });
    },
    deletePlan(id) {
      this.removePlan(id);
    },
    redirectToDivisions(planId) {
      this.$router.push(`/app/plans/view/${planId}`)
    }
  },

  async mounted() {
    if (!this.isLoggedIn) {
      this.message.info("Necesitas iniciar sesión para acceder a esta dirección", { duration: 5000 });
      this.$router.push('/app/login');
    }
    await this.getPlans();
  },
}
</script>

<style scoped>
.list-border {
  border-bottom: 1px solid var(--black)
}

.row-collapse-color1 {
  background-color: var(--white);
}

.row-collapse-color2 {
  background-color: var(--white);
}

.table-head-dark {
  background-color: var(--black);
  color: var(--white);
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: bold;
}

.table-border {
  border: solid var(--black) 2px;
}

.btn-crear-nuevo-plan {
  width: 15rem;
  height: 2.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  color: var(--white);
  background-color: var(--interaction-yellow);
  border: 1px solid var(--interaction-yellow);
  border-radius: var(--main-border-radius);
  padding: 1.375rem 2.125rem 1.375rem 2.125rem;
  border: 0.125rem solid #d6a02d;
  transition: all 0.3s;
  }

@media screen and (max-width: 700px) {

  .container-main-title {
    justify-content: center;
    text-align: center;
  }

  .main-title {
    width: 100%;
    margin-bottom: 40px;
  }


  .container-fluid {
    padding: 1rem !important;
  }

  .crear-nuevo-plan-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .title-in-row,
  .info-in-row {
    align-items: center;
    text-align: center;
  }

  .trash {
    position: relative;
    left: 43%;
  }

}
</style>